import {Injectable, Type} from '@angular/core';
import {RequestStepTypeEnum} from '@dto/requests/request-step-type.enum';
import {BaseRequestComponent} from './base-request-component';
import {AdaptiveCardRequestComponent} from './adaptive-card/adaptive-card-request.component';
import {FileRequestComponent} from './file/file-request.component';
import {GbgRequestComponent} from './gbg/gbg-request.component';
import {Validator} from '@shared/utilities/validator';

@Injectable({
  providedIn: 'root'
})
export class RequestComponentMappingService {

  public map(requestStepType: RequestStepTypeEnum): Type<BaseRequestComponent> {
    switch (requestStepType) {
      case RequestStepTypeEnum.AdaptiveCard:
        return AdaptiveCardRequestComponent;
      case RequestStepTypeEnum.FileDownload:
      case RequestStepTypeEnum.FileUpload:
        return FileRequestComponent;
      case RequestStepTypeEnum.GbgIdScan:
        return GbgRequestComponent;
    }

    Validator.verifySwitchHandledAllOptions(requestStepType);
  }
}
